export type AddRemoveObject<ChildKeyType> = { [parentUuid: string]: { add: ChildKeyType[]; remove: ChildKeyType[] } }

// export type AddRemoveStore<ChildKeyType = string> = ReturnType<typeof makeAddRemoveStore<ChildKeyType>>

export class AddRemoveStore<ChildKeyType = string> {
	#current: AddRemoveObject<ChildKeyType> = $state({})
	constructor() {
		//
	}
	/**
	 * Add a child item to a parent item. Also removes it from the `remove` list as well, if it is there.
	 * @param parentUuid The UUID of the parent item.
	 * @param childIds The UUID of the child item to add.
	 */
	add(parentUuid: string, childIds: MaybeArray<ChildKeyType>) {
		this.#current[parentUuid] ??= { add: [], remove: [] }
		if (!Array.isArray(childIds)) {
			childIds = [childIds]
		}
		this.#current[parentUuid].add.push(...childIds)
		this.#current[parentUuid].remove = this.#current[parentUuid].remove.filter(uuid => !childIds.includes(uuid))
	}

	remove(parentUuid: string, childIds: MaybeArray<ChildKeyType>) {
		this.#current[parentUuid] ??= { add: [], remove: [] }
		if (!Array.isArray(childIds)) {
			childIds = [childIds]
		}
		this.#current[parentUuid].remove.push(...childIds)
		this.#current[parentUuid].add = this.#current[parentUuid].add.filter(uuid => !childIds.includes(uuid))
	}

	// The Presage version of this had multiple other arguments to fitler it down to a list or something, but I don't think I need them here
	getAddIds(parentUuid: string): Array<ChildKeyType> {
		return this.#current[parentUuid]?.add ?? []
	}

	getRemoveIds(parentUuid: string): Array<ChildKeyType> {
		return this.#current[parentUuid]?.remove ?? []
	}

	clear() {
		this.#current = {}
	}

	get current() {
		return this.#current
	}

	set current(value: AddRemoveObject<ChildKeyType>) {
		this.#current = value
	}
}

type MaybeArray<T> = T | T[]
